"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KPI = void 0;
const react_1 = require("react");
const React = require("react");
require("./kpi.less");
class KPI extends react_1.Component {
    render() {
        const { isSymbolBefore = false, label = "", name = "", performance = "", symbol = "", unit = "" } = this.props;
        return (React.createElement("div", { className: "kpi" },
            React.createElement("div", { className: "kpi-content" },
                React.createElement("div", { className: "kpi-label" }, label),
                React.createElement("div", { className: "kpi-name" }, name),
                React.createElement("div", { className: "kpi-data" },
                    isSymbolBefore && React.createElement("span", { className: "kpi-symbol" }, symbol),
                    React.createElement("span", { className: "kpi-performance" }, Number(performance).toLocaleString()),
                    !isSymbolBefore && React.createElement("span", { className: "kpi-symbol" }, symbol),
                    unit && React.createElement("span", { className: "kpi-unit" }, unit)))));
    }
}
exports.KPI = KPI;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi/kpi.tsx
// module id = 3640
// module chunks = 0